// Translated
// Migrated
<template>
  <div class="flex flex-wrap -mx-4 p-3 room-container">
    <div class="md:w-8/12 px-4">
      <b-skeleton
        height="1.5rem"
        width="50%"
      />
      <div class="mt-4" />
      <b-skeleton width="70%" />
      <b-skeleton width="70%" />
      <b-skeleton width="70%" />
      <div class="mt-4" />
      <b-skeleton
        height="0.5rem"
        width="60%"
      />
    </div>
    <div class="md:w-4/12 px-4">
      <b-skeleton-img aspect="3:1" />
    </div>
  </div>
</template>
